/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BankMasterDto { 
    /**
     * 外部金融機関コード：数字
     */
    extBankfcCode?: string;
    /**
     * 外部支店コード：数字
     */
    extBranchCode?: string;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate?: string;
    /**
     * 金融機関漢字名：全角
     */
    bankfcAname?: string;
    /**
     * 金融機関漢字略称名：全角
     */
    bankfcKanjiRyaku?: string;
    /**
     * 金融機関全角カナ名：全角（カナ）
     */
    bankfcZkanaAname?: string;
    /**
     * 金融機関全角カナ略称名：全角（カナ）
     */
    bankfcKanaAname?: string;
    /**
     * 金融機関支店漢字名：全角
     */
    branchAname?: string;
    /**
     * 金融機関支店漢字略称名：全角
     */
    branchKanjiRyaku?: string;
    /**
     * 支店全角カナ名称：全角（カナ）
     */
    branchZkanaAname?: string;
    /**
     * 支店全角カナ略称名：全角（カナ）
     */
    branchKanaAname?: string;
    /**
     * 金融機関郵便番号：数字
     */
    postno?: string;
    /**
     * 代表行コード：数字
     */
    daihyoGyoCode?: string;
    /**
     * 代表行通番：数字
     */
    daihyoGyoSrno?: string;
    /**
     * 依頼返却可能日数：数字
     */
    reqretAbleDaycnt?: number;
    /**
     * 依頼返却可能時刻区分コード：数字<br>　　画面項目ID＝\'C007341\'
     */
    reqretAbleHmsdiv?: string;
    /**
     * 依頼返却可能時刻区分コード（名称）：全角
     */
    reqretAbleHmsdivAname?: string;
    /**
     * 金融機関受付締切時間区分：数字<br>　　画面項目ID＝\'C002030\'
     */
    bankfcAcclstDiv?: string;
    /**
     * 金融機関受付締切時間区分（名称）：全角
     */
    bankfcAcclstDivAname?: string;
    /**
     * 新規コード入力区分：数字<br>　　画面項目ID＝\'C012180\'
     */
    newcdInputDiv?: string;
    /**
     * 新規コード入力区分（名称）：全角
     */
    newcdInputDivAname?: string;
    /**
     * カナ名セット区分：数字<br>　　画面項目ID＝\'C012190\'
     */
    kanaSetDiv?: string;
    /**
     * カナ名セット区分（名称）：全角
     */
    kanaSetDivAname?: string;
    /**
     * 金融機関契約区分：数字<br>　　画面項目ID＝\'C012200\'
     */
    ctrDiv?: string;
    /**
     * 金融機関契約区分（名称）：全角
     */
    ctrDivAname?: string;
    /**
     * 支払区分：数字<br>　　画面項目ID＝\'C012210\'
     */
    payDiv?: string;
    /**
     * 支払区分（名称）：全角
     */
    payDivAname?: string;
    /**
     * 代表行区分：数字<br>　　画面項目ID＝\'C012230\'
     */
    dhlineDiv?: string;
    /**
     * 代表行区分（名称）：全角
     */
    dhlineDivAname?: string;
    /**
     * 収納代行区分：数字<br>　　画面項目ID＝\'C013010\'
     */
    rcptdkDiv?: string;
    /**
     * 収納代行区分（名称）：全角
     */
    rcptdkDivAname?: string;
    /**
     * 委託者コード：数字
     */
    cnsgnrCode?: string;
    /**
     * 委託者氏名：全角
     */
    cnsgnrName?: string;
    /**
     * 口座科目：数字<br>　　画面項目ID＝\'C000360\'
     */
    accntSbj?: string;
    /**
     * 口座科目（名称）：全角
     */
    accntSbjAname?: string;
    /**
     * 代表行口座番号：数字
     */
    dhlineAccntn?: string;
    /**
     * 種別コード：数字<br>　　画面項目ID＝\'C012970\'
     */
    clscod?: string;
    /**
     * 種別コード（名称）：全角
     */
    clscodAname?: string;
    /**
     * フォーマット区分：数字<br>　　画面項目ID＝\'C012470\'
     */
    fmlDiv?: string;
    /**
     * フォーマット区分（名称）：全角
     */
    fmlDivAname?: string;
    /**
     * 口振依頼ヘッダー作成コード：数字<br>　　画面項目ID＝\'C012530\'
     */
    khreqHeaderMakecd?: string;
    /**
     * 口振依頼ヘッダー作成コード（名称）：全角
     */
    khreqHeaderMakecdAname?: string;
    /**
     * 口振依頼送付票代表行カナ名：全角（カナ）
     */
    kfsndlDhlineKana?: string;
    /**
     * 口振依頼送付票代表行コード：数字
     */
    kfsndlDhlineCode?: string;
    /**
     * 口振媒体区分コード：数字<br>　　画面項目ID＝\'C012240\'
     */
    kohuriMediaDivcd?: string;
    /**
     * 口振媒体区分コード（名称）：全角
     */
    kohuriMediaDivcdAname?: string;
    /**
     * 口振結果受信タイミングコード：数字<br>　　画面項目ID＝\'C012550\'
     */
    kohuriRsljsnTmgcd?: string;
    /**
     * 口振結果受信タイミングコード（名称）：全角
     */
    kohuriRsljsnTmgcdAname?: string;
    /**
     * 口振依頼変換コード：数字<br>　　画面項目ID＝\'C012540\'
     */
    kfrreqCharCode?: string;
    /**
     * 口振依頼変換コード（名称）：全角
     */
    kfrreqCharCodeAname?: string;
    /**
     * 帳票出力順番：数字
     */
    prtoutJunban?: string;
    /**
     * ＭＴレコード無時ヘッダー作成有無コード：数字<br>　　画面項目ID＝\'C013810\'
     */
    norecHeaderMakecd?: string;
    /**
     * ＭＴレコード無時ヘッダー作成有無コード（名称）：全角
     */
    norecHeaderMakecdAname?: string;
    /**
     * 金融機関支店廃止日付：日付(yyyyMMdd)
     */
    bankfcHaisiDate?: string;
    /**
     * 金融機関マスターテーブル＿更新通番号：数字
     */
    bankMasterUpdateSrno?: string;
    /**
     * 金融機関変換マスターテーブル＿更新通番号：数字
     */
    bankHnknMasterUpdateSrno?: string;
}

